import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { FlexboxGrid } from 'rsuite'
import { InfoOutline } from '@rsuite/icons'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { Product } from '../../utils/types/Product'
import DiscountTableRow from './DiscountTableRow'
import TakeRateInfoPopover from './TakeRateInfoPopover'

import styles from '../../styles/DiscountTableRow.module.less'

interface DiscountTableSPPProps {
  product: Product
}

const DISCOUNT_TIERS = [2, 5, 10]

const DiscountTableSPP: FC<DiscountTableSPPProps> = ({ product }) => {
  const { t } = useTranslation('products')

  const sppDiscountTableV3FeatureFlag = useFeatureIsOn('spp-discount-table-v3')

  if (!sppDiscountTableV3FeatureFlag) {
    return null
  }

  return (
    <div className="margin-top-spacer-tripple">
      <FlexboxGrid justify="space-between">
        <FlexboxGrid.Item>
          <p className="h6">{t('Example amount')}</p>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item>
          <p className="h6">{t('Price & savings')}</p>
        </FlexboxGrid.Item>
      </FlexboxGrid>
      <DiscountTableRow
        product={product}
        discountTier={DISCOUNT_TIERS[0]}
      />
      <DiscountTableRow
        product={product}
        discountTier={DISCOUNT_TIERS[1]}
      />
      <DiscountTableRow
        product={product}
        discountTier={DISCOUNT_TIERS[2]}
      />
      <div className="margin-top-spacer-half">
        <span>{t('Tip See your personal volume discount grow in real-time with the progress bar above')}</span>
        <TakeRateInfoPopover>
          <InfoOutline className={styles['info-icon']} />
        </TakeRateInfoPopover>
      </div>
    </div>
  )
}

export default DiscountTableSPP
